module.exports = new __parcel__URL__("gears-darkmode.561e5a59.svg").toString();